const dict = {
  uk: {
    title: 'Розклад занять',
    selectDate: 'Оберіть дату',
    emptyDay: 'Немає запланованих уроків на цей день',
    calendar: {
      days: {
        mon: 'Пн',
        tue: 'Вт',
        wed: 'Ср',
        thu: 'Чт',
        fri: 'Пт',
        sat: 'Сб',
        sun: 'Нд',
      },
      dayLong: {
        sun: 'Неділя',
        mon: 'Понеділок',
        tue: 'Вівторок',
        wed: 'Середа',
        thu: 'Четвер',
        fri: 'П\'ятниця',
        sat: 'Субота',
      },
      months: {
        jan: 'Січень',
        feb: 'Лютий',
        mar: 'Березень',
        apr: 'Квітень',
        may: 'Травень',
        jun: 'Червень',
        jul: 'Липень',
        aug: 'Серпень',
        sep: 'Вересень',
        oct: 'Жовтень',
        nov: 'Листопад',
        dec: 'Грудень',
      },
    },
    lessonType: {
      trial: 'Пробний урок',
      club: 'Клуб',
      individual: 'Індивідуальний',
      group: 'Груповий',
      participantOne: '{{count}} учасник',
      participantFew: '{{count}} учасники',
      participantMany: '{{count}} учасників',
    },
    pendingPayment: 'Очікує оплати від учня',
    enterClass: 'Увійти в клас',
    preview: 'Перегляд',
    previewTooltip: 'Переглянути презентацію',
    previewUnavailableTooltip: 'Доступно за 24 години до заняття',
    program: 'Програма',
    assignProgramTooltip: 'Призначити програму',
    replace: 'Замінити',
    replaceTooltip: 'Замінити урок',
    personalize: 'Персоналізувати',
    editPersonalized: 'Редагувати персоналізацію',
    resetPersonalization: 'Скинути до оригіналу',
    resetPersonalizationConfirm: 'Скинути персоналізацію і повернути оригінальну презентацію для цього уроку?',
    assignProgramModal: {
      title: 'Призначити програму для {{name}}',
      lessonsCount: '{{count}} уроків',
    },
    alerts: {
      noPresentationTitle: 'Презентація відсутня',
      noPresentationMessage: 'До цього уроку ще не прив\'язано презентацію.',
      errorTitle: 'Помилка',
      presentationNotFound: 'Презентацію не знайдено.',
      loadPresentationFailed: 'Помилка завантаження презентації.',
      resetPersonalizationFailed: 'Не вдалося скинути персоналізацію.',
      programAssignedTitle: 'Успішно',
      programAssignedMessage: 'Програму "{{title}}" призначено для {{name}}',
      specialLessonSuccessTitle: 'Успіх',
      specialLessonSuccessMessage: 'Спеціальний урок призначено. Програма зсунеться на наступне заняття.',
    },
    manager: {
      title: 'Розклад курсу',
      viewList: 'Список',
      viewCalendar: 'Календар',
      progress: 'Прогрес: {{completed}} / {{total}} уроків',
      remaining: 'Залишилось: {{count}}',
      completionOn: 'Завершення: {{date}}',
      timeChanges: 'Змін часу: {{used}}/{{max}}',
      filterUpcoming: 'Майбутні',
      filterCompleted: 'Пройдені',
      filterAll: 'Усі',
      loading: 'Завантаження...',
      empty: 'Немає уроків',
      lessonNumber: 'Урок {{n}}',
      todayLabel: '(Сьогодні)',
      materials: 'Матеріали',
    },
    changeTime: {
      title: 'Змінити час уроку',
      pickDateAndTime: 'Оберіть дату та час',
      changeFailed: 'Не вдалося змінити час',
      changesUsedPrefix: 'Використано змін цього місяця:',
      changesUsedJoiner: 'з',
      limitReached: 'Ви вичерпали ліміт змін на цей місяць',
      currentTimeLabel: 'Поточний час:',
      newDateLabel: 'Нова дата:',
      newTimeLabel: 'Новий час:',
      submit: 'Змінити час',
      submitting: 'Збереження...',
    },
    changeTeacher: {
      title: 'Змінити викладача',
      pickTeacher: 'Оберіть викладача',
      failed: 'Не вдалося змінити викладача',
      warning: 'Зміна викладача може вплинути на розклад. Усі майбутні уроки будуть призначені новому викладачу.',
      currentTeacher: 'Поточний викладач:',
      pickNew: 'Оберіть нового викладача:',
      consent: 'Я розумію, що зміна викладача може вплинути на розклад та безперервність навчання',
      submit: 'Змінити викладача',
    },
  },
  en: {
    title: 'Lesson schedule',
    selectDate: 'Select a date',
    emptyDay: 'No lessons scheduled for this day',
    calendar: {
      days: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',
      },
      dayLong: {
        sun: 'Sunday',
        mon: 'Monday',
        tue: 'Tuesday',
        wed: 'Wednesday',
        thu: 'Thursday',
        fri: 'Friday',
        sat: 'Saturday',
      },
      months: {
        jan: 'January',
        feb: 'February',
        mar: 'March',
        apr: 'April',
        may: 'May',
        jun: 'June',
        jul: 'July',
        aug: 'August',
        sep: 'September',
        oct: 'October',
        nov: 'November',
        dec: 'December',
      },
    },
    lessonType: {
      trial: 'Trial lesson',
      club: 'Club',
      individual: 'Individual',
      group: 'Group',
      participantOne: '{{count}} participant',
      participantFew: '{{count}} participants',
      participantMany: '{{count}} participants',
    },
    pendingPayment: 'Awaiting payment from student',
    enterClass: 'Enter class',
    preview: 'Preview',
    previewTooltip: 'Preview presentation',
    previewUnavailableTooltip: 'Available 24 hours before the lesson',
    program: 'Program',
    assignProgramTooltip: 'Assign program',
    replace: 'Replace',
    replaceTooltip: 'Replace lesson',
    personalize: 'Personalize',
    editPersonalized: 'Edit personalization',
    resetPersonalization: 'Reset to original',
    resetPersonalizationConfirm: 'Reset personalization and restore the original presentation for this lesson?',
    assignProgramModal: {
      title: 'Assign program for {{name}}',
      lessonsCount: '{{count}} lessons',
    },
    alerts: {
      noPresentationTitle: 'No presentation',
      noPresentationMessage: 'No presentation has been linked to this lesson yet.',
      errorTitle: 'Error',
      presentationNotFound: 'Presentation not found.',
      loadPresentationFailed: 'Failed to load presentation.',
      resetPersonalizationFailed: 'Failed to reset personalization.',
      programAssignedTitle: 'Success',
      programAssignedMessage: 'Program "{{title}}" has been assigned to {{name}}',
      specialLessonSuccessTitle: 'Success',
      specialLessonSuccessMessage: 'Special lesson assigned. The program will shift to the next lesson.',
    },
    manager: {
      title: 'Course schedule',
      viewList: 'List',
      viewCalendar: 'Calendar',
      progress: 'Progress: {{completed}} / {{total}} lessons',
      remaining: 'Remaining: {{count}}',
      completionOn: 'Completion: {{date}}',
      timeChanges: 'Time changes: {{used}}/{{max}}',
      filterUpcoming: 'Upcoming',
      filterCompleted: 'Completed',
      filterAll: 'All',
      loading: 'Loading...',
      empty: 'No lessons',
      lessonNumber: 'Lesson {{n}}',
      todayLabel: '(Today)',
      materials: 'Materials',
    },
    changeTime: {
      title: 'Change lesson time',
      pickDateAndTime: 'Pick a date and time',
      changeFailed: 'Failed to change the time',
      changesUsedPrefix: 'Changes used this month:',
      changesUsedJoiner: 'of',
      limitReached: 'You have reached the change limit for this month',
      currentTimeLabel: 'Current time:',
      newDateLabel: 'New date:',
      newTimeLabel: 'New time:',
      submit: 'Change time',
      submitting: 'Saving...',
    },
    changeTeacher: {
      title: 'Change teacher',
      pickTeacher: 'Pick a teacher',
      failed: 'Failed to change teacher',
      warning: 'Changing the teacher can affect the schedule. All upcoming lessons will be assigned to the new teacher.',
      currentTeacher: 'Current teacher:',
      pickNew: 'Pick a new teacher:',
      consent: 'I understand that changing the teacher can affect the schedule and continuity of learning',
      submit: 'Change teacher',
    },
  },
};

export default dict;
